import { defineMessages } from "react-intl";

export const messages = defineMessages({
  redux_platform_member_einladung_wurde_zurueckgezogen: {
    id: "redux.platform.member.einladung.wurde.zurueckgezogen",
    defaultMessage: "Einladung wurde zurückgezogen.",
  },
  redux_platform_member_einladung_konnte_nicht_zurueckgezogen_werden: {
    id: "redux.platform.member.einladung.konnte.nicht.zurueckgezogen.werden",
    defaultMessage: "Einladung konnte nicht zurückgezogen werden.",
  },
  redux_platform_member_berechtigungen_wurden_angepasst: {
    id: "redux.platform.member.berechtigungen.wurden.angepasst",
    defaultMessage: "Berechtigungen wurden angepasst.",
  },
  redux_platform_member_fehler_beim_anpassen_der_berechtigungen: {
    id: "redux.platform.member.fehler.beim.anpassen.der.berechtigungen",
    defaultMessage: "Fehler beim Anpassen der Berechtigungen.",
  },
  redux_platform_einladung_wurde_versendet: {
    id: "redux.platform.einladung.wurde.versendet",
    defaultMessage: "Einladung wurde versendet.",
  },
  redux_platform_diese_email_wurde_bereits_erfolgreich_eingeladen: {
    id: "redux.platform.diese.email.wurde.bereits.erfolgreich.eingeladen",
    defaultMessage: "Diese E-Mail wurde bereits erfolgreich eingeladen.",
  },
  redux_platform_einladung_fehlgeschlagen: {
    id: "redux.platform.einladung.fehlgeschlagen",
    defaultMessage: "Einladung fehlgeschlagen!",
  },
  redux_platform_einladung_wurde_erneut_versendet: {
    id: "redux.platform.einladung.wurde.erneut.versendet",
    defaultMessage: "Einladung wurde erneut versendet.",
  },
});
